// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap, func-names, default-param-last */
import { Record, Map } from "immutable"
import * as PickerFormComposer from "@kiwicom/frontend-app/scripts/composers/PickerFormComposer"
import { NEXT_FIELD } from "@kiwicom/frontend-common/consts/form"
import SearchFormState from "@kiwicom/frontend-common/records/SearchFormState"
import PickPrices from "@kiwicom/frontend-common/records/PickPrices"
import SearchDate from "@kiwicom/frontend-common/records/SearchDate"
import SearchPlace from "@kiwicom/frontend-common/records/SearchPlace"
import * as PickerPricesComposer from "@kiwicom/frontend-common/services/pickers/pickerPricesComposer"

const SET_ACTIVE_MODE = "plainSearchForm/SET_ACTIVE_MODE"
const SET_ACTIVE_FIELD = "plainSearchForm/SET_ACTIVE_FIELD"
const SET_NEXT_FIELD = "plainSearchForm/SET_NEXT_FIELD"
const CHANGE_VALUE = "plainSearchForm/CHANGE_VALUE"
const CHANGE_FORM = "plainSearchForm/CHANGE_FORM"

const RESET_FORM = "plainSearchForm/RESET_FORM"
const PRICES_UNAVAILABLE = "plainSearchForm/PRICES_UNAVAILABLE"
const CLEAR_PRICES = "plainSearchForm/CLEAR_PRICES"

const LOAD_PRICES = "plainSearchForm/LOAD_PRICES"
const LOAD_PRICES_REQUEST = "plainSearchForm/LOAD_PRICES_REQUEST"
const LOAD_PRICES_SUCCESS = "plainSearchForm/LOAD_PRICES_SUCCESS"
const LOAD_PRICES_FAILURE = "plainSearchForm/LOAD_PRICES_FAILURE"

const PlainSearchFormState = Record({
  activeField: null,
  activeModes: new PickerFormComposer.ActiveModesRecord(),
  prices: new PickerPricesComposer.PricesRecord(),
  form: new SearchFormState(),
})

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line no-undef
function fillPlainSearchFormState(map: Map): PlainSearchFormState {
  return new PlainSearchFormState({
    ...map.toJS(),
    activeModes: new PickerFormComposer.ActiveModesRecord(),
    prices: new PickerPricesComposer.PricesRecord(),
    form: new SearchFormState({
      ...map.get("form").toJS(),
      origin: new SearchPlace(map.getIn(["form", "origin"])),
      destination: new SearchPlace(map.getIn(["form", "destination"])),
      outboundDate: new SearchDate(map.getIn(["form", "outboundDate"])),
      inboundDate: new SearchDate(map.getIn(["form", "inboundDate"])),
    }),
  })
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function (state = new PlainSearchFormState(), action: any) {
  if (!(state instanceof PlainSearchFormState)) return fillPlainSearchFormState(state)

  switch (action.type) {
    case SET_ACTIVE_MODE:
      return state.setIn(["activeModes", action.field], action.mode)

    case SET_ACTIVE_FIELD:
      return state.set("activeField", action.field)

    case SET_NEXT_FIELD:
      // @ts-expect-error: Flow to TS migration.
      return state.set("activeField", NEXT_FIELD[state.activeField])

    case CHANGE_FORM:
      return state.set("form", action.form)

    case RESET_FORM:
      return new PlainSearchFormState()

    case CHANGE_VALUE:
      return state.set(
        "form",
        // @ts-expect-error: Flow to TS migration.
        PickerFormComposer.handleFormChange(state.form, action.value, action.field),
      )

    // prices
    // ---
    case CLEAR_PRICES:
      // @ts-expect-error: Flow to TS migration.
      return state.set("prices", PickerPricesComposer.clearMonths(state.prices))

    case PRICES_UNAVAILABLE:
      return state.setIn(["prices", action.direction], new PickPrices({ unavailable: true }))

    case LOAD_PRICES_REQUEST:
      return state.set(
        "prices",
        // @ts-expect-error: Flow to TS migration.
        PickerPricesComposer.pricesLoadingRequest(state.prices, action.direction, action.monthId),
      )

    case LOAD_PRICES_SUCCESS:
      return state.set(
        "prices",
        PickerPricesComposer.pricesLoadingSuccess(
          // @ts-expect-error: Flow to TS migration.
          state.prices,
          action.direction,
          action.monthId,
          action.res,
        ),
      )

    case LOAD_PRICES_FAILURE:
      return state.set(
        "prices",
        PickerPricesComposer.pricesLoadingFailed(
          // @ts-expect-error: Flow to TS migration.
          state.prices,
          action.direction,
          action.monthId,
          action.err,
        ),
      )

    default:
      return state
  }
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setActiveMode(field: any, mode: any) {
  return {
    type: SET_ACTIVE_MODE,
    field,
    mode,
  }
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setActiveField(field: any) {
  return {
    type: SET_ACTIVE_FIELD,
    field,
  }
}

export function setNextField() {
  return {
    type: SET_NEXT_FIELD,
  }
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setValue(field: any, value: any, changeType: any) {
  return {
    type: CHANGE_VALUE,
    field,
    value,
    changeType,
    _track: { field, value, changeType },
  }
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setForm(form: any) {
  return {
    type: CHANGE_FORM,
    form,
  }
}

export function resetForm() {
  return {
    type: RESET_FORM,
  }
}

// prices
// ---
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function loadPrices(promise: any, monthId: any, direction: any) {
  return {
    type: LOAD_PRICES,
    promise,
    monthId,
    direction,
  }
}

export function clearPrices() {
  return {
    type: CLEAR_PRICES,
  }
}
